<template>
  <b-form-group :label="label"
                label-for="name">
    <b-form-textarea :id="name"
                  :name="name"
                  autocomplete="off"
                  :rows="rows"
                  :max-rows="maxRows"
                  type="text"
                  v-model="inputValue"
                  v-validate="validate"
                  :state="errors.has(name) ? false : null"
                  :aria-describedby="name + 'Feedback'"
                  :placeholder="placeholder">
    </b-form-textarea>
    <b-form-invalid-feedback :id="name + 'Feedback'">
      {{errors.first(name)}}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: false
      },
      name: {
        type: String,
        required: true
      },
      placeholder: {
        type: String,
        default: ''
      },
      value: {
        required: true
      },
      validate: {
        type: String,
        default: ''
      },
      validator: {
        type: Object
      },
      rows: {
        type: Number,
        default: 1
      },
      maxRows: {
        type: Number,
        default: 4
      },
      autofocus: {
        required: false
      }
    },
    data() {
      return {
        inputValue: this.value,
      }
    },
    created() {
      this.$validator = this.validator
    },
    mounted() {
      if (this.autofocus) {
        setTimeout(() => this.$el.querySelector('textarea').focus(), 0)
      }
    },
    watch: {
      inputValue() {
        this.$emit('input', this.inputValue)
      },
      value() {
        this.inputValue = this.value
      }
    }
  }
</script>
